import { Route } from "react-router-dom";

import Website from "Screens/Website";

const websiteRoutes = [<Route path="/" key="home" element={<Website />} />];

export default websiteRoutes;
